import { DeliveryBucketItemResponse } from "../../../common/api/delivery-api/GetDeliveryBucketListResponse";
import { DeliveryBucketAccessType } from "../create/common/DeliveryBucketAccessType";

export type DeliveryBucketItem = KeyBasedDeliveryBucketItem | RoleBasedDeliveryBucketItem;

interface BaseDeliveryBucketItem {
    deliveryBucketId: string;
    bucketName: string;
    uniqueId: string;
    originator: string;
    isActive: boolean;
    isModified?: boolean;
    originatorId: string;
}

interface KeyBasedDeliveryBucketItem extends BaseDeliveryBucketItem {
    accessType: DeliveryBucketAccessType.Key;
    resources: {
        keyAge: string;
    };
}

interface RoleBasedDeliveryBucketItem extends BaseDeliveryBucketItem {
    accessType: DeliveryBucketAccessType.Role;
    resources: {
        roleName: string;
        roleArn: string;
    };
}

export const mapToDeliveryBucketItem = (item: DeliveryBucketItemResponse): DeliveryBucketItem => {
    switch (item.accessType) {
        case DeliveryBucketAccessType.Key: {
            return {
                deliveryBucketId: item.deliveryBucketId,
                bucketName: item.bucketName,
                accessType: item.accessType,
                uniqueId: item.uniqueId,
                originator: item.originator,
                isActive: item.isActive,
                originatorId: item.originatorId,
                resources: {
                    keyAge: item.resources.keyAgeInDays || "-"
                },
                isModified: false
            };
        }
        case DeliveryBucketAccessType.Role: {
            return {
                deliveryBucketId: item.deliveryBucketId,
                bucketName: item.bucketName,
                accessType: item.accessType,
                uniqueId: item.uniqueId,
                originator: item.originator,
                originatorId: item.originatorId,
                isActive: item.isActive,
                resources: {
                    roleName: item.resources.roleName,
                    roleArn: item.resources.roleArn
                },
                isModified: false
            };
        }
        default:
            throw new Error("Incorrect access type for delivery bucket");
    }
};
